module.exports = __webpack_public_path__ + "img/cuban-zombie.bdbb68e1.jpg";